import { render, staticRenderFns } from "./_UserGroupForm.vue?vue&type=template&id=4ee47a04&"
import script from "./_UserGroupForm.vue?vue&type=script&lang=ts&"
export * from "./_UserGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports